export default "https://cdn-static.gokick.com/assets/a667d1dc3297954618d7ed7be4de1ad72d2b7ee9/images/sleep-blueberry.3ee2bf0b929baac3dd5c59083edb83bb.png";